import { useSelector } from "react-redux";

import MainSection from "../components/home/MainSection";
import ContentWithCards from "../components/shared/ContentWithCards";
// import BannerCarousel from "../components/shared/BannerCarousel";

const Home = () => {
  const userData = useSelector((state) => state.auth?.userData);

  return (
    <ContentWithCards>
      <div className="main-section">
        {/* Banner Carousel for Ads */}
        {/* <BannerCarousel /> */}
        
        <MainSection userData={userData} />
      </div>
    </ContentWithCards>
  );
};

export default Home;
